var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: _vm.title,
        width: _vm.width,
        top: _vm.top,
        "before-close": _vm.handleBeforeClose,
        "close-on-click-modal": _vm.closeOnClickModal,
        "append-to-body": _vm.appendToBody,
        "destroy-on-close": _vm.destroyOnClose,
        "custom-class": _vm.dialogClassComputed,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
        open: function ($event) {
          return _vm.$emit("open")
        },
        closed: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c(
        "div",
        { class: _vm.contentClassComputed },
        [
          _vm.usePanel
            ? _c(
                "div",
                { class: ["sk-panel", _vm.panelVariantClass] },
                [
                  _vm.showPanelHead
                    ? _c("div", { staticClass: "sk-panel-head" }, [
                        _vm.showPanelIcon
                          ? _c(
                              "div",
                              {
                                class: [
                                  "sk-panel-icon",
                                  _vm.panelIconToneClass,
                                ],
                              },
                              [
                                _vm._t("panel-icon", function () {
                                  return [_c("i", { class: _vm.panelIcon })]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c("div", [
                          _vm.$slots["panel-title"] || _vm.panelTitle
                            ? _c(
                                "p",
                                { staticClass: "sk-panel-title" },
                                [
                                  _vm._t("panel-title", function () {
                                    return [_vm._v(_vm._s(_vm.panelTitle))]
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.$slots["panel-subtitle"] || _vm.panelSubtitle
                            ? _c(
                                "p",
                                { staticClass: "sk-panel-subtitle" },
                                [
                                  _vm._t("panel-subtitle", function () {
                                    return [_vm._v(_vm._s(_vm.panelSubtitle))]
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          !(
                            _vm.$slots["panel-subtitle"] || _vm.panelSubtitle
                          ) && _vm.panelText
                            ? _c("p", { staticClass: "sk-panel-subtitle" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.panelText) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._t("default"),
                ],
                2
              )
            : _vm._t("default"),
        ],
        2
      ),
      _c(
        "span",
        {
          class: _vm.footerClassComputed,
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm._t("footer", function () {
            return [
              _vm.showCancel
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: {
                        type: _vm.cancelType,
                        disabled: _vm.cancelDisabled,
                      },
                      on: { click: _vm.handleCancel },
                    },
                    [
                      _vm.cancelIcon
                        ? _c("i", { class: _vm.cancelIcon })
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(_vm.cancelText))]),
                    ]
                  )
                : _vm._e(),
              _vm.showConfirm
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: {
                        type: _vm.confirmType,
                        loading: _vm.confirmLoading,
                        disabled: _vm.confirmDisabled,
                      },
                      on: { click: _vm.handleConfirm },
                    },
                    [
                      _vm.confirmIcon
                        ? _c("i", { class: _vm.confirmIcon })
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(_vm.confirmText))]),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }